import {
    contains,
    curry,
    endsWith,
    equals,
    gt,
    gte,
    lt,
    lte,
    startsWith
} from 'lodash/fp';
import { formatRow } from 'components/atoms/tables/smarttables/helpers/helper';

// curried function filters rows with a provided function in the format of fn(b)(a)
const fpFilter = curry((fn, rows, id, value) => rows.filter(row => fn(value)(formatRow(row, 'formatFilterValue')[id])));
const fpFilterInverse = curry((fn, rows, id, value) => rows.filter(row => !fn(value)(formatRow(row, 'formatFilterValue')[id])));
// case insensitive versions
const fpFilterI = curry((fn, rows, id, value) => rows.filter(row => fn(String(value).toLowerCase())(String(formatRow(row, 'formatFilterValue')[id]).toLowerCase())));
const fpFilterInverseI = curry((fn, rows, id, value) => rows.filter(row => !fn(String(value).toLowerCase())(String(formatRow(row, 'formatFilterValue')[id]).toLowerCase())));
// normalize the arg order for lodash/fp methods to fn(b)(a)
const fpFilterRearg = fn => fpFilter(fn.convert({ rearg: true }));

const filters = {
    eq: {
        label: 'Equals (Exact Match)',
        fn: fpFilter(equals),
    },
    doesNotEq: {
        label: 'Does Not Equal',
        fn: fpFilterInverse(equals),
    },
    eq_num: {
        label: '=',
        fn: fpFilter(equals),
    },
    doesNotEq_num: {
        label: '!=',
        fn: fpFilterInverse(equals),
    },
    contains: {
        label: 'Contains',
        fn: fpFilterI(contains),
    },
    doesNotContain: {
        label: 'Does Not Contain',
        fn: fpFilterInverseI(contains),
    },
    sw: {
        label: 'Starts With',
        fn: fpFilterI(startsWith),
    },
    ew: {
        label: 'Ends With',
        fn: fpFilterI(endsWith),
    },
    gt: {
        label: '>',
        fn: fpFilterRearg(gt),
    },
    gte: {
        label: '>=',
        fn: fpFilterRearg(gte),
    },
    lt: {
        label: '<',
        fn: fpFilterRearg(lt),
    },
    lte: {
        label: '<=',
        fn: fpFilterRearg(lte),
    },
    is: {
        label: 'is',
        fn: fpFilter(equals),
    },
    isNot: {
        label: 'is not',
        fn: fpFilterInverse(equals),
    }
};

const filterSets = {
    textColumnFilter: ['contains', 'doesNotContain', 'eq', 'doesNotEq', 'sw', 'ew'],
    numericColumnFilter: ['eq_num', 'doesNotEq_num', 'gt', 'gte', 'lt', 'lte'],
    booleanFilter: ['is', 'isNot']
};

const filterOptionSets = Object.entries(filterSets).reduce((acc, cur) => {
    const [filterName, filterValues] = cur;
    acc[filterName] = filterValues.map(key => ({
        key,
        text: filters[key].label,
        value: key
    }));
    return acc;
}, {});

export {
    filters,
    filterSets,
    filterOptionSets,
};



// WEBPACK FOOTER //
// ./src/components/atoms/tables/smarttables/helpers/filters.js